import { createSvgIcon } from "@mui/material/utils";

export const CompositionIcon = createSvgIcon(
  <svg viewBox="0 0 15 15" fill="none">
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".167"
      d="M11.456.084c.363 0 .669.305.669.669v1.726h1.726c.364 0 .67.306.67.67 0 .39-.309.669-.67.669h-1.726v6.969h1.726c.364 0 .67.305.67.669 0 .39-.309.669-.67.669h-1.726v1.726c0 .39-.308.67-.67.67a.65.65 0 0 1-.668-.67v-1.726H3.818v1.726c0 .39-.309.67-.67.67a.65.65 0 0 1-.669-.67v-1.726H.753a.647.647 0 0 1-.67-.67c0-.36.28-.668.67-.668h1.726V3.818H.753a.65.65 0 0 1-.67-.67c0-.36.28-.669.67-.669h1.726V.753c0-.361.28-.67.67-.67.363 0 .669.306.669.67v1.726h6.969V.753c0-.362.279-.67.669-.67ZM3.818 10.787h6.969V3.818H3.818z"
    />
  </svg>,
  "CompositionIcon",
);
